<template>
  <div class="wrapper" id="haoLian">
    <header class="flex-wrap pageTop">
      <div class="flex-start">
        <div class="logo">
          <img src="../../../../static/images/dutyInsurance/logo.png" alt="小白保险logo" title="小白保险" @click='goTo("/haoLian")'>
        </div>
        <div class="home">
          <img src="../../../../static/images/dutyInsurance/home.png" alt="首页logo" title="首页" @click='goTo("/haoLian")'>
        </div>
      </div>
    </header>
    <main class="contentModule">
      <transition name="router-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
    <footer>
      <div>
        <ul class="site-info">
          <li>版权所有：正迅保险经纪股份有限公司</li>
          <li>联系电话：020-82526981</li>
          <li>地址：广州市黄埔区开创大道2403号1003室</li>
        </ul>
        <div>粤ICP备13035223号-3</div>
      </div>
    </footer>
  </div>
</template>

<script>
  import baseUrl from '../../../tool/baseUrl'
  import $$ from "../../../tool/BaseXJT";
  import Axios from "axios";
  export default {
    name: "haoLian",
    data() {
      return {
        current: 'haoLian',
        token: '',
      }
    },
    methods:{
      goTo(title){
        this.current = title;
        if (!$$.isValidObj(this.token)) {
          this.$$.alert({message: "请求未带标识，token不能为空!"});
          return false;
        }
        this.$$.isValidObj(this.token) ? this.$router.push({path: `${title}`, query: {token: this.token}}) : this.$router.push({path: `${title}`});
      },
    },
    mounted() {
      let that = this;
      that.current = that.$route.name;
      let token = that.$route.query.token,
        value = that.$$.localStorageGet('MYRCIB_THIRD_PARTY_TOKEN');

      if ($$.isValidObj(token)){
        if (!$$.isValidObj(value) || value != token) that.$$.localStorageSet('MYRCIB_THIRD_PARTY_TOKEN', token);
        that.token = token;
      } else {
        that.$$.alert({message: "请求未带标识，token不能为空!", onOk: function () {
          if (that.current != 'index') that.$router.push({path: `/haoLian`});
        }});
      }

    },
  }
</script>

<style scoped>
  .wrapper>footer{
    background: #06060B!important;
    color: #9D9DC0;
    font-weight: bold;
    font-size: 1rem;
    text-align: center;
  }
  .wrapper>footer>div{
    width: 80%;
    margin: 0 auto;
    padding: 4rem 0rem;
    max-width: 1600px;
  }
  .wrapper>footer>div .site-info{
    display: inline-block;
  }
  .wrapper>footer>div .site-info>li{
    display: inline-block;
    margin-right: 2rem;
    margin-bottom: 1.5rem;
  }
  .home>img{
    width: 3rem;
    height: 3rem;
    cursor: pointer;
    vertical-align: middle;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/haoLian/haoLian.vue